import {
    ResponseDto as ICompareTariff,
} from '@r1-frontend/api-domru/api-profile/v2/change-tariff/compare-tariff/dto/ResponseDto';

import { IInternetPlan } from '@r1-frontend/shared/types/tariff/IInternetPlan';

import { InferValueTypes } from '~/src/store';

import * as actionCreators from './actions';

export const actionTypes = {
    SET_AVAILABLE_TARIFF_PLANS: '@LK/SET_AVAILABLE_TARIFF_PLANS',
    SET_COMPARE_DATA: '@LK/SET_COMPARE_DATA',
    CLEAR_DATA: '@LK/CLEAR_DATA',
    SET_LOADING: '@LK/SET_LOADING',
    SET_START_COMPARE: '@LK/SET_START_COMPARE',
    SET_LOADING_STATUS: '@LK/SET_LOADING_STATUS',
    SET_ERROR: '@LK/SET_ERROR',
} as const;

export enum ELoadingStatus {
    notInit = 'notInit',
    loading = 'loading',
    successAvailable = 'successAvailable',
    startCompare = 'startCompare',
    successCompare = 'successCompare',
    error = 'error',
}

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

const reducer = (state: IInitialState = initialState, action: TActions): IInitialState => {
    switch (action.type) {
        case actionTypes.SET_LOADING: {
            return {
                ...state,
                loadingStatus: ELoadingStatus.loading,
            };
        }
        case actionTypes.SET_AVAILABLE_TARIFF_PLANS: {
            return {
                ...state,
                availableTariffPlans: action.payload,
                loadingStatus: ELoadingStatus.successAvailable,
            };
        }
        case actionTypes.SET_START_COMPARE: {
            return {
                ...state,
                loadingStatus: ELoadingStatus.startCompare,
            };
        }
        case actionTypes.SET_COMPARE_DATA: {
            const { key, data } = action.payload;
            return {
                ...state,
                compareData: {
                    ...state.compareData,
                    [key]: data,
                },
                loadingStatus: ELoadingStatus.successCompare,
            };
        }
        case actionTypes.SET_LOADING_STATUS: {
            return {
                ...state,
                loadingStatus: action.payload,
            };
        }
        case actionTypes.SET_ERROR: {
            return {
                ...initialState,
                error: action.payload,
                loadingStatus: ELoadingStatus.error,
            };
        }
        case actionTypes.CLEAR_DATA: {
            return {
                ...initialState,
            };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};

export interface IInitialState {
    loadingStatus: ELoadingStatus,
    availableTariffPlans: IInternetPlan[],
    compareData: Record<number, ICompareTariff>,
    error: string,
}

export const initialState: IInitialState = {
    loadingStatus: ELoadingStatus.notInit,
    availableTariffPlans: [],
    compareData: {},
    error: '',
};

export default reducer;
